import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import track from 'react-tracking';
import BEMHelper from '@ynap/bem-helper';
import { trackPage } from '../analytics';
import { raygun } from '@ynap/clientside-monitoring';

const bem = new BEMHelper('ErrorPage');

@track()
export default class SimpleErrorPage extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        action: PropTypes.func.isRequired,
        actionLabel: PropTypes.string.isRequired,
        displayMessage: PropTypes.string.isRequired,
        error: PropTypes.shape({
            status: PropTypes.string,
            message: PropTypes.string,
        }),
        prevPath: PropTypes.string,
        country: PropTypes.string,
        language: PropTypes.string,
        deviceType: PropTypes.string,
    };

    @track(trackPage)
    componentDidMount() {
        const { error, displayMessage = 'error page', prevPath } = this.props;
        if (error) {
            const url = raygun.helpers.getUnlocalisedUrl(window?.location?.pathname);
            raygun.helpers.agent('send', {
                error: new Error(`error page: ${displayMessage}`),
                tags: ['error-page', `${error?.status}`, `${error?.message}`, url],
                customData: {
                    ...error,
                    prevPath: prevPath || document.referrer,
                },
            });
        }
    }

    render() {
        const { className, displayMessage, action, actionLabel } = this.props;

        return (
            <div className={bem(null, null, className)}>
                <div className={bem('container')}>
                    <h3 className={bem('title')}>{displayMessage}</h3>

                    <p className={bem('link')} onClick={action}>
                        {actionLabel}
                    </p>
                </div>
            </div>
        );
    }
}
